<template>
  <div class="searchWrapper">
      <div class="search" v-if="!notInput">姓名：</div>
      <input class="input" type="text" placeholder="请输入学生姓名"  v-model="searchText.name" style='outline:none;' v-if="!notInput">
      <div class="search" v-if="!notInput">性别：</div>
      <select class="input" v-model="searchText.sex" placeholder="请选择性别" style='outline:none;'>
        <option value='全选'>全选</option>
        <option value='男'>男</option>
        <option value='女'>女</option>
      </select>
      <div class="search" v-if="!notInput">寝室号：</div>
      <input class="input" type="text" placeholder="请输入寝室号"  v-model="searchText.roomNo" style='outline:none;' v-if="!notInput">
      <div class="search" v-if="!notInput">是否归寝：</div>
      <select class="input" v-model="searchText.isReturn" placeholder="请选择是否归寝" style='outline:none;'>
        <option value='全选'>全选</option>
        <option value='是'>是</option>
        <option value='否'>否</option>
      </select>
      <div class="search" v-if="!notInput">是否绑定：</div>
      <select class="input" v-model="searchText.isPush" placeholder="请选择是否归寝" style='outline:none;'>
        <option value='全选'>全选</option>
        <option value='是'>是</option>
        <option value='否'>否</option>
      </select>
      <div class="button" v-for="(item,i) in buttonList" :key="i" @click="active(i)">
        <img :src="item.url" v-if="item.url">
        <div class="tip">{{item.name}}</div>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        buttonList:{
            type:Array
        },
        notInput:{
            type:Boolean
        }
    },
    data(){
        return{
            searchText:{
                name:null,
                sex:'全选',
                roomNo:null,
                isReturn:'全选',
                isPush:'全选'
            }
        }
    },
    methods:{
        active(e){
            this.$emit('active',e,this.searchText)
        }
    }
}
</script>

<style lang="scss">
.searchWrapper{
    display: flex;
    // background-color: #fff;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    .search{
        font-size: 0.83rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #3E3A39;
        padding-left: .5rem;
    }
    .input{
        height: 70%;
        width: 10vw;
        min-width: 7rem;
        border: 0;
        border-radius: 3px;
    }
    .input::placeholder {
        font-size: 0.5rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #B5B5B6;
    }
    .input::-webkit-input-placeholder {
        color: #B5B5B6;
        font-size: 0.5rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
    }
    .input::-moz-placeholder {
        color: #B5B5B6;
        font-size: 0.5rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
    }
    .input::-ms-input-placeholder {
        color: #B5B5B6;
        font-size: 0.5rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
    }
    .button{
        border: 1px rgba(0, 0, 0, 0) solid;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 0.83rem;
        background-color: #3399FF;
        height: 70%;
        border-radius: 3px;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 0.75rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        img{
            margin-right: 0.3rem;
            width: 0.7rem;
            height: 0.8rem;
        }
    }
    .button:active{
        border: 1px #000 solid;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/search.vue